import { useNavigate } from "react-router-dom";
import { KeyRound, FileLock2, ShieldQuestion, ArrowRight, ShieldCheck } from "lucide-react";

const Choice = ({ icon: Icon, title, description, details, onClick, testid }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    className="group text-left rounded-2xl border border-slate-200 bg-white p-6 hover:border-emerald-300 hover:shadow-sm transition-all"
  >
    <div className="flex items-start gap-4">
      <div className="w-12 h-12 rounded-xl bg-emerald-50 border border-emerald-100 flex items-center justify-center shrink-0">
        <Icon className="w-6 h-6 text-emerald-600" />
      </div>
      <div className="min-w-0 flex-1">
        <h2 className="font-heading text-xl font-bold text-slate-900">{title}</h2>
        <p className="text-sm text-slate-500 mt-1 leading-relaxed">{description}</p>
        <p className="text-xs text-slate-400 mt-3">{details}</p>
        <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-700 group-hover:gap-2.5 transition-all">
          Continuer <ArrowRight className="w-4 h-4" />
        </div>
      </div>
    </div>
  </button>
);

export const SendHub = () => {
  const navigate = useNavigate();
  return (
    <div data-testid="send-hub" className="space-y-8 max-w-5xl">
      <div>
        <span className="text-xs font-semibold tracking-[0.18em] uppercase text-emerald-600">Nouvel envoi</span>
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight mt-1">Que souhaitez-vous envoyer ?</h1>
        <p className="text-slate-500 mt-3 max-w-2xl">Choisissez le type de contenu. SecurePass ouvre ensuite le parcours existant correspondant, sans modifier son fonctionnement de sécurité.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        <Choice
          testid="send-password-choice"
          icon={KeyRound}
          title="Mot de passe ou secret"
          description="Saisissez ou générez un mot de passe puis utilisez les modes de remise déjà disponibles : lien, e-mail ou SMS sécurisé selon votre offre."
          details="Génération et chiffrement existants conservés."
          onClick={() => navigate("/generateur")}
        />
        <Choice
          testid="send-file-choice"
          icon={FileLock2}
          title="Fichier sécurisé"
          description="Sélectionnez un fichier et utilisez le parcours Secure Files déjà en place. Le chiffrement reste effectué côté navigateur."
          details="Aucun changement du circuit Secure Files."
          onClick={() => navigate("/fichiers")}
        />
      </div>

      <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5 flex items-start gap-3">
        <ShieldCheck className="w-5 h-5 text-emerald-600 mt-0.5 shrink-0" />
        <div>
          <div className="font-semibold text-slate-900">Vous souhaitez recevoir une information d'un tiers ?</div>
          <p className="text-sm text-slate-500 mt-1">Utilisez le parcours distinct « Demander une information » : le sens de l'échange est inversé.</p>
          <button onClick={() => navigate("/demander")} className="mt-2 inline-flex items-center gap-1 text-sm font-semibold text-emerald-700 hover:text-emerald-600">
            <ShieldQuestion className="w-4 h-4" /> Créer une demande
          </button>
        </div>
      </div>
    </div>
  );
};
